import { render, staticRenderFns } from "./commissionPerformance.vue?vue&type=template&id=6e12bdc4&scoped=true&"
import script from "./commissionPerformance.vue?vue&type=script&lang=js&"
export * from "./commissionPerformance.vue?vue&type=script&lang=js&"
import style0 from "./commissionPerformance.vue?vue&type=style&index=0&id=6e12bdc4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e12bdc4",
  null
  
)

export default component.exports